import React, { useContext, useEffect, useRef, useState } from "react";
import { Avatar, Button, Chip } from "@mui/material";
import toast from "react-hot-toast";

import ReferralList from "../../components/ReferralComponent/ReferralList";
import ReferralSuccessModal from "../../components/Modals/ReferralSuccessModal";
import Image from "../../Assets/img/covers/userDefault.png";
import referImg from "../../Assets/img/registration/refer-earn.png";
import ReferAndEarnHeader from "../../components/ReferralComponent/TopBanner";
import { AppContext } from "../../appContext";
import { getUserApi, RefferListByID, RefferSendInviteAPI } from "../../apis";
import { EditProfileLoader } from "../../components/common/loader";
import ReferralHistoryComponent from "../../components/ReferralComponent/ReferralHistoryComponent";
import { IoIosArrowBack } from "react-icons/io";
import useDeviceType from "../../utils/useDeviceType";

export default function ReferralSection() {
  // Refs
  const codeInputRef = useRef(null);

  const deviceType = useDeviceType();

  // Local state
  const [shareCode, setShareCode] = useState(false);
  const [sharePressed, setSharePressed] = useState(false);
  const [showShareSuccessModal, setShowShareSuccessModal] = useState(false);

  const [email, setemail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // Helpers
  const isValidEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test((value || "").trim());
  };

  const validateEmailAndSetError = (value) => {
    const trimmed = (value || "").trim();
    if (!trimmed) {
      setErrorMessage("Email cannot be empty");
      return false;
    }
    if (!isValidEmail(trimmed)) {
      setErrorMessage("Please enter a valid email address");
      return false;
    }
    setErrorMessage("");
    return true;
  };
  const [profileData, setprofileData] = useState("");
  const [referraldata, setreferraldata] = useState(null);
  const [loading, setloading] = useState(false);
  const [referralloading, setreferralloading] = useState(false);

  const fetchData = async () => {
    try {
      const res = await getUserApi();
      if (res.status === 200) {
        console.log("profile", res?.data?.Profile);
        setprofileData(res?.data?.Profile);
        fetchDataRefferal(res?.data?.Profile?.DoctorProfile?._id);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const fetchDataRefferal = async (id) => {
    try {
      setreferralloading(true);

      //const res = await RefferListByID('68b52924916c7ea8052553ca');
      const res = await RefferListByID(id || profileData?.DoctorProfile?._id);
      if (res.status === 200) {
        console.log(res.data.doctors);
        setreferraldata(res.data.doctors);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setreferralloading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  // Handlers
  const handleCopy = () => {
    const input = codeInputRef.current;
    if (input) {
      navigator.clipboard
        .writeText(input.value || "")
        .then(() => toast.success("Code Copied!"))
        .catch(() => toast.error("Failed to copy code."));
    } else {
      toast.error("Input not found.");
    }
  };

  const handleShare = async () => {
    setShareCode(true);
    setSharePressed(true);
  };

  const handleEmailChange = (e) => {
    const val = e.target.value;
    setemail(val);
    if (sharePressed) {
      if (isValidEmail(val)) setErrorMessage("");
    }
  };

  const handleSendClick = async () => {
    if (!validateEmailAndSetError(email)) {
      setShowShareSuccessModal(false);
      return;
    }
    try {
      setloading(true);
      const res = await RefferSendInviteAPI({
        my_code: profileData?.DoctorProfile?.my_code,
        email_id: email,
      });
      if (res.status === 200) {
        setShowShareSuccessModal(true);
        setemail('');
      } else {
        toast.error("Failed to Send Invite");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message || error.message);
    } finally {
      setloading(false);
      setShareCode(false);
      setSharePressed(false);
    }
  };

  const handleBackClick = () => {
    setShareCode(false);
    setemail("");
    setErrorMessage("");
  };

  const ReferralSuccessModalBody = (
    <>
      <h2 className="font-semibold text-xl md:text-2xl md:mt-8">
        Invite sent!
      </h2>
      <p className=" text-gray-600 mt-5 md:mt-7 text-base md:text-lg px-3 mt-6">
        You’ve successfully sent an invitation to your friend.
      </p>
    </>
  );

  return (
    <>
      <section className="pt-[14%] pb-10 max-w-md md:max-w-[90vw] md:pt-[16%] md:ml-[auto] md:mr-[auto] lg:ml-1  lg:bg-transparent  lg:pt-[0px] lg:pb-[0px] lg:my-7 lg:px-2 marginx_auto custom_x_margin custom_pt_lg">
        <div className="flex justify-center items-center flex ml-auto mr-auto flex-col gap-1 bg-color-referral md:bg-transparent">
          <ReferAndEarnHeader
            image={referImg}
            text="Earn Rewards By Referring"
          />

          {deviceType === "Mobile" ? (
            <>
              {/* smaller devices */}
              {!shareCode ? (
                <>
                  <div className="flex flex-row justify-between gap-3 lg:gap-5 items-center relative mt-5 w-full ">
                    <span className="flex flex-row items-center justify-between p-2 border border-[#d0d0d0] rounded-xl md:w-4/5 w/full">
                      <input
                        ref={codeInputRef}
                        className="line-clamp-1 transparent-input-border px-md-3 text-white md:text-[#9b9898] w-full bg-transparent"
                        id="referralCode"
                        placeholder="Referral Code"
                        value={profileData?.DoctorProfile?.my_code}
                        readOnly
                      />
                      <Button
                        variant="text"
                        onClick={handleCopy}
                        // remove color="white"
                        size="small"
                        className="!text-white md:!text-[rgb(155_152_152_/var(--tw-text-opacity))]"
                      >
                        Copy
                      </Button>
                    </span>

                    <button
                      type="button"
                      className="ms-0 ms-lg-2 py-3 px-6 rounded-xl text-white md:w-1/5"
                      onClick={handleShare}
                      style={{ backgroundColor: "#1648ce", color: "#ffff" }}
                    >
                      Share
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div
                    id="referral-email-input"
                    className="flex flex-row justify-between gap-3 lg:gap-5 items-center relative mt-5 w-full "
                  >
                    <span
                      className="border-[#d0d0d0] flex items-center justify-between border rounded-xl md:w-1/5 p-1"
                      onClick={handleBackClick}
                    >
                      <IoIosArrowBack className="text-base text-white p-1.5 w-9 h-9 rounded-full lg:hidden" />
                    </span>

                    <span
                      className={`flex flex-row items-center justify-between border rounded-xl w-full md:w-3/5 ${
                        errorMessage ? "custom-err-border" : "border-[#d0d0d0]"
                      }`}
                    >
                      <input
                        className="line-clamp-1 transparent-input-border px-3 p-2 py-3 rounded-xl w-full mobile-button-forinput"
                        id="referralMail"
                        placeholder="Enter Email ID"
                        value={email}
                        onChange={handleEmailChange}
                        maxLength={30}
                      />
                    </span>

                    <button
                      type="button"
                      className=" ms-0 ms-lg-2 py-3 px-6 rounded-xl text-white md:w-1/5hite md:w-1/5"
                      onClick={handleSendClick}
                      style={{ backgroundColor: "#1648ce" }}
                    >
                      {loading ? <EditProfileLoader /> : "Send"}
                    </button>
                  </div>
                  {errorMessage && (
                    <div className="w-full">
                      <p className="custom-err-text mt-1.5 mb-1.5 text-sm text-left">
                        {errorMessage}
                      </p>
                    </div>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              {/* larger devices */}
              <div className="flex flex-row justify-between gap-3 lg:gap-5 items-center relative mt-5 w-full ">
                <span className="flex flex-row items-center justify-between p-2 border border-[#d0d0d0] rounded-xl md:w-4/5 w/full">
                  <input
                    ref={codeInputRef}
                    className="line-clamp-1 transparent-input-border px-md-3 text-white md:text-[#9b9898] w-full bg-transparent"
                    id="referralCode"
                    placeholder="Referral Code"
                    value={profileData?.DoctorProfile?.my_code}
                    readOnly
                  />
                  <Button
                    variant="text"
                    onClick={handleCopy} // remove color="white" size="small"
                    className="!text-white md:!text-[rgb(155_152_152_/var(--tw-text-opacity))]"
                    sx={{
                      borderRadius: 2,         
                      backgroundColor: "#f1f1f1",
                    }}
                  >
                    Copy
                  </Button>
                </span>

                <button
                  type="button"
                  className="ms-0 ms-lg-2 py-3 px-6 rounded-xl text-white md:w-1/5"
                  onClick={handleShare}
                  style={{ backgroundColor: "#2D5AD3", color: "#ffff" }}
                >
                  Share
                </button>
              </div>

              {shareCode && (
                <>
                  <div
                    id="referral-email-input"
                    className="flex flex-row justify-between gap-3 lg:gap-5 items-center relative mt-5 w-full "
                  >
                    <span
                      className={`flex flex-row items-center justify-between border rounded-xl w-full md:w-4/5 ${
                        errorMessage ? "border-red-400" : "border-[#d0d0d0]"
                      }`}
                    >
                      <input
                        className="line-clamp-1 transparent-input-border px-3 p-2 py-3 rounded-xl w-full mobile-button-forinput"
                        id="referralMail"
                        placeholder="Enter Email ID"
                        value={email}
                        onChange={handleEmailChange}
                        maxLength={30}
                      />
                    </span>

                    <button
                      type="button"
                      className=" ms-0 ms-lg-2 py-3 px-6 rounded-xl text-white md:w-1/5hite md:w-1/5"
                      onClick={handleSendClick}
                      style={{ backgroundColor: "#2D5AD3" }}
                    >
                      {loading ? <EditProfileLoader /> : "Send"}
                    </button>
                  </div>
                  {errorMessage && (
                    <div className="w-full">
                      <p className="text-danger mt-1.5 mb-1.5 text-sm text-left">
                        {errorMessage}
                      </p>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>

        <div className="flex flex-col mt-10 referral-section-another">
          <div className="flex flex-row items-center justify-between mb-3">
            <h3 className="text-lg font-semibold mb-2 me-auto">
              Referred List
            </h3>

            {/* <Button
              variant="text"
              className="!text-gray-500 !underline underline-offset-3"
              size="small"
              sx={{ textTransform: "none" }}
              href="/wallet"
            >
              Earnings
            </Button> */}
            <ReferralHistoryComponent />
          </div>

          <ReferralList list={referraldata} loading={referralloading} />
        </div>
      </section>

      {showShareSuccessModal && (
        <ReferralSuccessModal
          bodyContent={ReferralSuccessModalBody}
          onClose={() => setShowShareSuccessModal(false)}
        />
      )}
    </>
  );
}
